import BreadcrumbsPath from "../../../../api/breadcrumbsPathEntity";

export const notifyBreadcrumChangeAction = (actionType: string, latestPageTitle: string) => ({
  payload: latestPageTitle,
  type: actionType
});

export const notifyBreadcrumChangeOnContentPageAction = (actionType: string, breadcrumbsPath: BreadcrumbsPath ) => ({
  payload: breadcrumbsPath,
  type: actionType
});


// WEBPACK FOOTER //
// ./src/common/components/breadcrumb/actions/notifyBreadcrumChange.ts